import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "@/i18n"; // Initialize i18n
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);

// PWA: globalne przechwycenie promptu instalacji (zdarzenie potrafi paść przed mountem komponentu).
if (typeof window !== 'undefined') {
  window.__deferredInstallPrompt = window.__deferredInstallPrompt || null;
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.__deferredInstallPrompt = e;
    window.dispatchEvent(new Event('pwa-installable'));
  });
  window.addEventListener('appinstalled', () => {
    window.__deferredInstallPrompt = null;
    window.dispatchEvent(new Event('pwa-installed'));
  });
}

// PWA: rejestracja Service Workera przy starcie (instalowalność „jak aplikacja").
// Ten sam SW obsługuje też push (pushNotifications.js reużywa rejestracji).
// UWAGA: nazwa pliku NIE może zaczynać się od "api" (proxy /api kierowałoby ją do backendu -> 404).
// Najpierw wyrejestrowujemy przestarzałe SW z poprzednich buildów (powodowały 404 w konsoli).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      for (const reg of regs) {
        const url = (reg.active || reg.waiting || reg.installing)?.scriptURL || '';
        if (url && !url.endsWith('/push-sw.js')) await reg.unregister();
      }
    } catch (e) { /* noop */ }
    navigator.serviceWorker.register('/push-sw.js', { scope: '/' }).catch(() => {});
  });
}
